import React, { Component } from 'react';
import { modifyAutorenewFlagFetch } from '../../../libs/fetch';

import './ToggleBtn.css';

class ToggleBtn extends Component {

    constructor(props) {
        super(props);
        this.state = {
            active: props.active,
            id: props.id,
            checked: (props.active) ? 'checked' : '',
            cvvGuidAlert: false
        }

        // binding
        // this.modifyAutorenewFlag = this.modifyAutorenewFlag.bind(this);
        this.autopayModified = this.autopayModified.bind(this);

    }

    autopayModified = (info, param) => {

        this.props.autopayModified(info, param);
    }


    // modifyAutorenewFlag
    // set autorenewFlag state 
    modifyAutorenewFlag = () => {
        this.autopayModified(true);//for showing the loading in the parent view.

        this.forceUpdate(() => {
            let params = {
                linked_user_id: this.state.id,
                flag: !this.state.active ? 1 : 0,
            }

            try {

                modifyAutorenewFlagFetch(this, params).then((response) => {
                    this.autopayModified(false);//for stopping the loading in the parent view.
                    console.log(response);
                    if (response.status = 'success') {
                        // // this.props.autopayModified();
                        // let autorenewState = this.state.active;
                        let checkedFlag = (this.state.active) ? '' : 'checked';
                        this.autopayModified(false, checkedFlag);//for showing the loading in the parent view.

                        // this.setState({ active: autorenewState });
                        this.setState({ checked: checkedFlag, active: !this.state.active });

                    }
                });
            } catch (e) {
                console.log(e);
            }
        });
    }

    // render
    render() {
        console.log("togglesw: ", this.state);

        return (
            <label className="switch">
                <input type="checkbox" checked={this.state.checked} onChange={this.modifyAutorenewFlag} />
                <span className="slider round"></span>
            </label>
        );
    }
}

export default ToggleBtn;


// WEBPACK FOOTER //
// ./src/assets/components/toggle/ToggleBtn.js